import { render, staticRenderFns } from "./logoSetting.vue?vue&type=template&id=a8bebb48&scoped=true&"
import script from "./logoSetting.vue?vue&type=script&lang=js&"
export * from "./logoSetting.vue?vue&type=script&lang=js&"
import style0 from "./logoSetting.vue?vue&type=style&index=0&id=a8bebb48&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bebb48",
  null
  
)

export default component.exports